import PropTypes from 'prop-types'

const FlagGR = ({ width = '20', height = '20', className = '', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 40"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Black stripe */}
    <rect x="0" y="0" width="60" height="13.33" fill="#000000" />
    {/* Red stripe */}
    <rect x="0" y="13.33" width="60" height="13.33" fill="#DD0000" />
    {/* Gold stripe */}
    <rect x="0" y="26.66" width="60" height="13.34" fill="#FFCE00" />
  </svg>
)

FlagGR.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

export default FlagGR
